


<!-- Header -->

<header class="header-area">

    <div class="top-header top-header-style-four">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <ul class="top-header-contact-info">
                        <li>
                            <strong i18n>Call</strong>: 
                            <a href="tel:+447447419596">00447447419596</a>
                        </li>
                    </ul>
                    <div class="top-header-social">
                        <span i18n>Follow us:</span>
                        <a href="https://www.facebook.com/aleshansab" target="_blank"><i class='bx bxl-facebook'></i></a>
                        <a href="#" target="_blank"><i class='bx bxl-twitter'></i></a>
                        <a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a>
                        <a href="#" target="_blank"><i class='bx bxl-instagram'></i></a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4">
                    <ul class="top-header-login-register">
                        <li><a routerLink="/login"><i class='bx bx-log-in'></i> <span i18n>Login</span></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- Navbar -->
    <div
        class="navbar-area"
        [ngClass]="{'sticky': isSticky}"
        [class.dark-navbar-area]="themeService.isDark()"
    >
        <div class="container-fluid">
            <nav class="navbar navbar-expand-lg navbar-light bg-light" [class.active]="classApplied">
                <a
                    class="navbar-brand"
                    routerLink="/"
                    [class.d-none]="themeService.isDark()"
                >
                    <img src="assets/img/black-logo.png" alt="logo" class="mandish-logo">
                </a>
                <a
                    class="navbar-brand d-none"
                    routerLink="/"
                    [class.d-block]="themeService.isDark()"
                >
                    <img src="assets/img/logo.png" alt="logo" class="mandish-logo">
                </a>
                <button class="navbar-toggler" type="button" (click)="toggleClass()">
                    <span class="burger-menu">
                        <span class="top-bar"></span>
                        <span class="middle-bar"></span>
                        <span class="bottom-bar"></span>
                    </span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav">
                        <li class="nav-item"><a routerLink="/" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Home</a></li>
                    
                        <li class="nav-item"><a href="javascript:void(0)" class="nav-link"><span i18n>History</span><i class='bx bx-chevron-down'></i></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item"><a routerLink="books/history/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Books</a></li>
                                <li class="nav-item"><a routerLink="/articles/history/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Articles</a></li>
                                <li class="nav-item"><a routerLink="biographies" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Biography</a></li>
                                <li class="nav-item"><a routerLink="news-papers" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>News Papers and Magazins</a></li>
                                <li class="nav-item"><a routerLink="menuscripts" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Menuscripts</a></li>
                            </ul>
                        </li>

                        <li class="nav-item"><a href="javascript:void(0)" class="nav-link"><span i18n>Geography</span> <i class='bx bx-chevron-down'></i></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item"><a routerLink="books/geography/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Books</a></li>
                                <li class="nav-item"><a routerLink="/articles/geography/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Articles</a></li>
                                <!-- <li class="nav-item"><a routerLink="/geography/maps" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Maps</a></li>
                                <li class="nav-item"><a routerLink="/geography/mines" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Mines</a></li>
                                <li class="nav-item"><a routerLink="/geography/environments" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Environments</a></li> -->
                            </ul>
                        </li>

                        <li class="nav-item"><a href="javascript:void(0)" class="nav-link"><span i18n>Projects</span> <i class='bx bx-chevron-down'></i></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item"><a routerLink="/projects/architecture/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Architectures</a></li>
                                <li class="nav-item"><a routerLink="/projects/education/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Educations</a></li>
                                <li class="nav-item"><a routerLink="/projects/history-geography/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>History and Geography</a></li>
                                <li class="nav-item"><a routerLink="/projects/culture-people/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n> Culture and People </a></li>
                            </ul>
                        </li>

                        <li class="nav-item"><a href="javascript:void(0)" class="nav-link"><span i18n>Culture and Society</span><i class='bx bx-chevron-down'></i></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item"><a routerLink="/articles/cloths/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Cloths</a></li>
                                <li class="nav-item"><a routerLink="/articles/jewelries/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Jewelries</a></li>
                                <li class="nav-item"><a routerLink="/articles/cermonies/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Cermonies</a></li>
                                <li class="nav-item"><a routerLink="/articles/sport_hobies/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Sport and Hobies</a></li>
                                <li class="nav-item"><a routerLink="/articles/chestans/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Chestan</a></li>
                                <li class="nav-item"><a routerLink="/articles/dubaities/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Dubaities</a></li>
                                <li class="nav-item"><a routerLink="/articles/fictions/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Fictions</a></li>
                                <li class="nav-item"><a routerLink="/articles/foods/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Foods</a></li>
                                <li class="nav-item"><a routerLink="/articles/agriculture/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Agriculture</a></li>
                                <li class="nav-item"><a routerLink="/articles/others/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Others</a></li>
                            </ul>
                        </li>
                        <li class="nav-item"><a routerLink="/blogs" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Blogs</a></li>
                        <li class="nav-item"><a routerLink="/events" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Events</a></li>
                        <li class="nav-item"><a routerLink="/multimedia" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Multimedia</a></li>


                        <li class="nav-item"><a href="javascript:void(0)" class="nav-link"><span i18n>Architectures</span> <i class='bx bx-chevron-down'></i></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item"><a routerLink="/articles/restoration/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Restoration</a></li>
                                <li class="nav-item"><a routerLink="/articles/conservation/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Conservation</a></li>
                                <li class="nav-item"><a routerLink="/articles/consolidation/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Consolidation</a></li>
                                <li class="nav-item"><a routerLink="/articles/revitalization/list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n> Revitalization </a></li>
                            </ul>
                        </li>
                        <li class="nav-item"><a routerLink="/abouts" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>About</a></li>
                        <li class="nav-item"><a routerLink="/contact" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" i18n>Contact</a></li>
                    </ul>
                </div>
                <div class="others-option">
                    <div class="dropdown language-switcher d-inline-block" [class.active]="classApplied2">
                        <button class="dropdown-toggle" type="button" (click)="toggleClass2()">
                            <span><span i18n>Lang</span> <i class='bx bx-chevron-down'></i></span>
                        </button>
                        <div class="dropdown-menu">
                            <a (click)="onLanguageChange(1)" class="dropdown-item d-flex align-items-center">
                                <span>English</span>
                            </a>
                            <a (click)="onLanguageChange(2)" class="dropdown-item d-flex align-items-center">
                                <span>فارسی</span>
                            </a>
                        </div>
                    </div>
                    
                    <!-- <div class="search-box d-inline-block">
                        <i class='bx bx-search' (click)="toggleClass3()"></i>
                    </div> -->
                </div>
            </nav>
        </div>
    </div>
    
</header>

<!-- Search Overlay -->
<div
    class="search-overlay"
    [class.active]="classApplied3"
    [class.dark-search-overlay]="themeService.isDark()"
>
    <div class="d-table">
        <div class="d-table-cell">
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-close" (click)="toggleClass3()">
                <span class="search-overlay-close-line"></span>
                <span class="search-overlay-close-line"></span>
            </div>
            <div class="search-overlay-form">
                <form>
                    <input type="text" class="input-search" placeholder="Search here...">
                    <button type="submit"><i class='bx bx-search-alt'></i></button>
                </form>
            </div>
        </div>
    </div>
</div>